const resetScrollPosition = () => window.scrollTo(0, 0);

// NOTE: remove this disable once more than one util in this file
// eslint-disable-next-line import/prefer-default-export
export { resetScrollPosition };
